import React from 'react';
import { Heart } from 'lucide-react';

const allDonors = [
  { 
    name: 'Bryan S De La Cruz',
    type: 'mlb',
    position: 'Outfielder',
    team: 'Miami Marlins / Atlanta Braves',
    image: 'https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?w=400&h=400&fit=crop'
  },
  { 
    name: 'Charities Aid Foundation America',
    type: 'organization',
    description: 'An international grantmaking organization that helps donors support charities around the world with ease and efficiency.',
    logo: 'https://via.placeholder.com/200x80/06b6d4/FFFFFF?text=CAF+America'
  },
  { 
    name: 'Chiawei Fang',
    type: 'individual'
  },
  { 
    name: 'Cristian Mieses',
    type: 'individual'
  },
  { 
    name: 'Dameury Pena Sanchez',
    type: 'individual'
  },
  { 
    name: 'Daniel Castillo',
    type: 'individual'
  },
  { 
    name: 'Diego Castillo',
    type: 'mlb',
    position: 'Relief Pitcher',
    team: 'Tampa Bay Rays / Seattle Mariners',
    image: 'https://images.unsplash.com/photo-1575361204480-aadea25e6e68?w=400&h=400&fit=crop'
  },
  { 
    name: 'Domingo Acevedo',
    type: 'mlb',
    position: 'Relief Pitcher',
    team: 'New York Yankees / Toronto Blue Jays',
    image: 'https://images.unsplash.com/photo-1566577739112-5180d4bf9390?w=400&h=400&fit=crop'
  },
  { 
    name: 'Dominican Equities LLC',
    type: 'organization',
    description: 'An investment and asset management company specializing in real estate and business ventures in the Dominican Republic and the United States.',
    logo: 'https://via.placeholder.com/200x80/3b82f6/FFFFFF?text=Dominican+Equities'
  },
  { 
    name: 'Elier Hernandez',
    type: 'individual'
  },
  { 
    name: 'F J Sports Management LLC',
    type: 'organization',
    description: 'A professional sports management agency representing athletes and providing career guidance, contract negotiations, and brand partnerships.',
    logo: 'https://via.placeholder.com/200x80/8b5cf6/FFFFFF?text=FJ+Sports'
  },
  { 
    name: 'Francisco Perez',
    type: 'mlb',
    position: 'MLB Player',
    team: 'Professional Baseball',
    image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400&h=400&fit=crop'
  },
  { 
    name: 'Huascar Brazoban',
    type: 'mlb',
    position: 'Relief Pitcher',
    team: 'Los Angeles Dodgers / Arizona Diamondbacks',
    image: 'https://images.unsplash.com/photo-1566577134770-3d85bb3a9cc4?w=400&h=400&fit=crop'
  },
  { 
    name: 'Jefry Rodriguez',
    type: 'individual'
  },
  { 
    name: 'Jose Caballero',
    type: 'individual'
  },
  { 
    name: 'Jose Cisnero',
    type: 'individual'
  },
  { 
    name: 'Juan Minaya',
    type: 'individual'
  },
  { 
    name: 'Kervin Castro Reina',
    type: 'individual'
  },
  { 
    name: 'Lisbeth Faneytt',
    type: 'individual'
  },
  { 
    name: 'Major League Baseball',
    type: 'organization',
    description: 'The premier professional baseball organization representing 30 teams across North America, committed to supporting communities and youth development.',
    logo: 'https://via.placeholder.com/200x80/0f172a/FFFFFF?text=MLB'
  },
  { 
    name: 'MD Logic Wellness',
    type: 'organization',
    description: 'A comprehensive wellness and healthcare services provider focused on preventive care, integrative medicine, and holistic health solutions.',
    logo: 'https://via.placeholder.com/200x80/06b6d4/FFFFFF?text=MD+Logic'
  },
  { 
    name: 'Miguel Sanchez',
    type: 'individual'
  },
  { 
    name: 'Rafael Devers',
    type: 'mlb',
    position: 'Third Baseman',
    team: 'Boston Red Sox',
    image: 'https://images.unsplash.com/photo-1624526267942-ab0ff8a3e972?w=400&h=400&fit=crop'
  },
  { 
    name: 'Raul Alcantara',
    type: 'individual'
  },
  { 
    name: 'Raynel Espinal Rodriguez',
    type: 'individual'
  },
  { 
    name: 'Sandro Fabian',
    type: 'individual'
  },
  { 
    name: 'Steward Berroa Gallatte',
    type: 'individual'
  },
  { 
    name: 'Warner Madrigal',
    type: 'individual'
  }
];

const DonorCard = ({ donor }) => {
  return (
    <div className="bg-gradient-to-br from-white to-cyan-50 p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-cyan-100">
      <div className="flex items-center">
        <div className="w-12 h-12 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center text-white font-bold mr-4 flex-shrink-0 text-lg">
          {donor.name.charAt(0)}
        </div>
        <p className="font-semibold text-gray-800">{donor.name}</p>
      </div>
    </div>
  );
};

const Donors = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-cyan-400 to-blue-500 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-300/10 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <Heart className="w-12 h-12 md:w-16 md:h-16 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontWeight: '400' }}>Our</span>{' '}
            <span className="font-black">Donors</span>
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Our charitable programs change lives thanks to the generous donors who make this all possible.
          </p>
        </div>
      </section>

      {/* All Donors Section */}
      <section className="py-20 bg-gradient-to-br from-white via-cyan-50/30 to-blue-50/30">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
            {allDonors.map((donor, index) => (
              <DonorCard key={index} donor={donor} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-cyan-400 to-blue-500 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontWeight: '400' }}>Join Our Community</span>{' '}
            <span className="font-black">of Donors</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl mb-8 max-w-2xl mx-auto leading-relaxed">
            Your contribution helps us provide mentorship, resources, and opportunities to deserving young individuals.
          </p>
          <a href="/donate">
            <button className="bg-white text-cyan-600 px-8 md:px-10 py-5 md:py-6 rounded-full font-bold text-base md:text-lg hover:bg-gray-100 transition-all hover:shadow-2xl hover:scale-105">
              Make a Donation
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Donors;